import { useCallback, useEffect, useState } from 'react';
import { cooldownSecondsLeft, MAGIC_LINK_RESEND_COOLDOWN_MS } from './resendCooldown';

/** Seconds until another magic link may be requested; `start()` after each successful send. */
export function useResendCooldown() {
  const [endsAt, setEndsAt] = useState<number | null>(null);
  const [secondsLeft, setSecondsLeft] = useState(0);

  useEffect(() => {
    if (endsAt === null) return;
    const tick = () => {
      const left = cooldownSecondsLeft(endsAt, Date.now());
      setSecondsLeft(left);
      if (left === 0) setEndsAt(null);
    };
    tick();
    const timer = window.setInterval(tick, 1000);
    return () => window.clearInterval(timer);
  }, [endsAt]);

  const start = useCallback(() => setEndsAt(Date.now() + MAGIC_LINK_RESEND_COOLDOWN_MS), []);

  return { secondsLeft, start };
}
